import React from "react";
import { BsSearch } from "react-icons/bs";
import InvoiceTable from "../../../UI/Table/InvoiceTable";
const ViewPurchase = () => {
  const Interval = [
    { interval: "Week" },
    { interval: "Month" },
    { interval: "Year" },
  ];
  const TableHeading = [
    { heading: "Table No" },
    { heading: "Particular" },
    { heading: "Refrence No" },
    { heading: "Date" },
    { heading: "Total" },
    { heading: "Status" },
  ];
  const TableData = [
    {
      sn: 1,
      name: "Kisan Mahat",
      invc: "7656",
      date: "2023/01/02",
      total: 36434,
    },
    {
      sn: 1,
      name: "Kisan Mahat",
      invc: "7656",
      date: "2023/01/02",
      total: 36434,
    },
    {
      sn: 1,
      name: "Kisan Mahat",
      invc: "7656",
      date: "2023/01/02",
      total: 36434,
    },
    {
      sn: 1,
      name: "Kisan Mahat",
      invc: "7656",
      date: "2023/01/02",
      total: 36434,
    },
    {
      sn: 1,
      name: "Kisan Mahat",
      invc: "7656",
      date: "2023/01/02",
      total: 36434,
    },
    {
      sn: 1,
      name: "Kisan Mahat",
      invc: "7656",
      date: "2023/01/02",
      total: 36434,
    },
    {
      sn: 1,
      name: "Kisan Mahat",
      invc: "7656",
      date: "2023/01/02",
      total: 36434,
    },
    {
      sn: 1,
      name: "Kisan Mahat",
      invc: "7656",
      date: "2023/01/02",
      total: 36434,
    },
  ];
  const pagination = [{ page: 1 }, { page: 2 }, { page: 3 }];

  return (
    <div className="flex flex-col mt-10 px-7">
      {/* <div className="flex justify-between items-center">
        <div className="tittle">All Purchase</div>
        <div className="flex items-center gap-4">
          <div className="">Sort By :</div>
          <div className="space-x-2">
            <button className="px-2 py-2 transition-all duration-300 text-sm rounded-md hover:shadow-md bg-[#ECF2FF]">
              Name
            </button>
            <button className="px-2 py-2 transition-all duration-300 text-sm rounded-md hover:shadow-md bg-[#ECF2FF]">
              Most Visit
            </button>
          </div>
        </div>
      </div> */}
      {/* <div className="flex items-center my-10 gap-32">
        <div className="">
          <select
            className=" w-fit  bg-[#ECF2FF] text-black border border-none  py-2 px-4 pr-8 rounded-md leading-tight focus:outline-none "

            // value={selectedOption}
            // onChange={handleOptionChange}
          >
            {Interval.map((val, i) => {
              return (
                <option key={i} value={"value"}>
                  {val.interval}
                </option>
              );
            })}
          </select>
        </div>
        <div className="flex  gap-5 w-full justify-between items-center ">
          <div className=" w-full">
            <input
              type="text"
              name="search"
              className="w-full py-3 px-4 focus:outline-none border-b-2 border-gray-500 "
              placeholder="Search...."
            />
          </div>
          <div className="">
            <button className="button-main">
              <BsSearch />
            </button>
          </div>
        </div>
      </div> */}
      <div className="">
        <InvoiceTable TableHeading={TableHeading} TableData={TableData} />
      </div>
      <div className="py-5 w-full flex justify-end gap-1">
        <button className="px-4 py-2 rounded-md transition-all duration-300 bg-second hover:bg-main hover:text-white">
          Prev
        </button>
        {pagination.map((val, i) => {
          return (
            <button
              key={i}
              className="px-4 py-2 rounded-md transition-all duration-300 bg-second hover:bg-main hover:text-white"
            >
              {val.page}
            </button>
          );
        })}
        <button className="px-4 py-2 rounded-md transition-all duration-300 bg-second hover:bg-main hover:text-white">
          Next
        </button>
      </div>
    </div>
  );
};

export default ViewPurchase;
